import React from 'react';
import * as Sentry from '@sentry/browser';
import { Route, createHashRouter, RouterProvider, createRoutesFromElements, Outlet } from "react-router-dom";
import { Provider, connect } from "react-redux";
import { plain_object, configure_drr } from 'django-rest-react';
import { createRoot } from 'react-dom/client';

import { DEBUG, sentry_config, TESTING } from '../globals'
import store from '../store'
import { LoadingBar, APIErrorCatcher, Loadable, ToastFeed } from '../common-components'
import { IscrizioneStage, NoMatch, NuovaPersona } from '../screens'
import { get_whoami } from '../api'
import { add_toast_action, del_toast_action, delete_old_toasts, set_user_data } from '../actions'
import { reducers_map, useLogin } from '../reducers'
import { LoginStateProps, sentry_log } from '../utils';



const LayoutFactory = (elem: React.ReactNode, effects: boolean) => () => {
  return (
    <div className="d-flex flex-column justify-content-between" id="contenitore">
      <div>
        <LoadingBar />
        <br />
        <div style={{ position: 'relative', zIndex: 3 }}>
          <div style={{ position: 'relative', zIndex: 1000 }}>
            <ToastFeed del_toast_action={id => store.dispatch(del_toast_action(id))} />
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            {elem}
          </div>
        </div>
      </div>
    </div>
  );
}


const Layout = LayoutFactory(<Outlet />, true)
const ErrorElement = LayoutFactory(<APIErrorCatcher get_username={(s: LoginStateProps["login"]) => s.user.username} useLogin={useLogin} sentry_config={sentry_config} />, false)


export const ROUTES = (
  <Route path="/*" element={<Layout />} errorElement={<ErrorElement />}>
    <Route path="iscrizione/" element={<IscrizioneStage />} />
    <Route path="iscrizione/:pk/" element={<IscrizioneStage />} />
    <Route path="persona-new/" element={<NuovaPersona />} />
  </Route>
)



export const AppFactory = (creator: typeof createHashRouter, store_: typeof store) => () => {
  const router = creator(createRoutesFromElements(ROUTES))
  return (
    <Loadable load={carica} log_error={sentry_log}>
      <Provider store={store_}>
        <RouterProvider router={router} />
      </Provider>
    </Loadable>
  )
}
const App = AppFactory(createHashRouter, store);

export default App;



const wrapper = document.getElementById("app");
const cusu = document.getElementById("user");
const username = cusu ? cusu.textContent : "__not_logged_in";
const carica: () => Promise<plain_object> =
  async () => {
    const get_connection_toast = (val: string) => {
      return {
        title: "Connessione persa",
        message: "Tentativo di riconnessione in corso",
        generating_object: val,

      }
    }


    configure_drr(
      reducers_map, store,
      DEBUG,
      val => delete_old_toasts(get_connection_toast(val)),
      val => add_toast_action(get_connection_toast(val)),
    );

    if (username != "__not_logged_in") {
      return get_whoami()
        .then(io => {
          store.dispatch(set_user_data(io));
          return {};
        })
    }
    return new Promise((resolve) => resolve({}));
  }



const mapRoutesToArray = (routes: typeof ROUTES) => {
  const paths = [] as string[];
  const children = routes.props.children;
  children.map((route: typeof ROUTES.props.children[0]) => {
    const inner = route.props.path;
    if (!inner) return
    if (Array.isArray(inner)) {
      paths.concat(inner)
    } else {
      paths.push(inner as string)
    }
  })
  return paths;
}

export const generate_sitemap = () => mapRoutesToArray(ROUTES)


if (sentry_config.use_sentry) {
  Sentry.init({
    dsn: sentry_config.dsn,
    release: sentry_config.release,
  });
}


if (!TESTING) {
  createRoot(wrapper).render(<App />)
}
